import { render, staticRenderFns } from "./majorProducts.vue?vue&type=template&id=c1d6e4ca&scoped=true&"
import script from "./majorProducts.vue?vue&type=script&lang=ts&"
export * from "./majorProducts.vue?vue&type=script&lang=ts&"
import style0 from "./majorProducts.vue?vue&type=style&index=0&id=c1d6e4ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1d6e4ca",
  null
  
)

export default component.exports